import { ActionsCell } from "../../../../Component/Common/Components/DataTable/ActionsCell";
import { DefaultCell } from "../../../../Component/Common/Components/DataTable/DefaultCell";
import { EEScorecard } from "../../../../Component/Model/Dto/EmploymentEquity/EEScorecard";
import { DateFormatter } from "../../../../Component/Model/helpers";
import {ActionType, TableColumn} from "../../../../Component/Model/Table/Table";
import {ConsolidationStatus} from "../../../../Component/Model/Enum/ConsolidationStatus";

interface HistoryTableRow {
    ID: number,
    Status: string,
    Result: string,
    CreatedBy: string,
    CreatedDate: string,
    Actions?:    ActionType[];
}


export interface IHistoryTable {
    columns: Array<TableColumn>;
    rows: Array<HistoryTableRow>;
}

export function HistoryTableMapper(results: EEScorecard.History[], resolveConflicts : (consolidationId:number) => void): IHistoryTable {
    const columns = [
        { Header: 'Date Created', accessor: 'CreatedDate', Cell: ({ value }: any) => <DefaultCell value={value} />, disableSortBy: true  },
        { Header: 'Status', accessor: 'Status', Cell: ({ value }: any) => <DefaultCell value={value} />, disableSortBy: true  },
        { Header: 'Result', accessor: 'Result', Cell: ({ value }: any) => <DefaultCell value={value} />, disableSortBy: true },
        { Header: 'Created By', accessor: 'CreatedBy', Cell: ({ value }: any) => <DefaultCell value={value} />, disableSortBy: true },
        { Header: 'Actions', accessor: 'Actions', Cell: ({ value }: any) => <ActionsCell actions={value} />, disableSortBy: true },
    ];

    if (results.length >= 0) {

        const rows = results.map((item: EEScorecard.History, index: number) => (
            {
                ID: item.id,
                Status: item.status,
                Result: item.result,
                CreatedBy: item.createdBy,
                CreatedDate: DateFormatter(item.createdDate.toString()),
                Actions: [
                    {
                        key: index.toString(),
                        label: 'Resolve Conflicts',
                        action: () => {
                            resolveConflicts(item.id);
                        },
                        icon: {
                            color: 'build',
                            name: 'build'
                        }
                    },
                ].filter(a => item.status === ConsolidationStatus.ActionRequired.toString() && a !== null)
            }));

        return { columns: columns, rows: rows };
    }else{
        return { columns: columns, rows: [] };
    }
}